import clsx from 'clsx';
import React from 'react';

import { User } from '../../../utils/backend-api/currentUser';
import UserAvatar, { AvatarSizes } from '../../User/UserAvatar';
import UserProfileLink from '../../User/UserProfileLink';
import TopicPill from './TopicPill';
import styles from './styles.module.scss';

const AVATAR_DISPLAY_LIMIT = 3;

const seperatebyDelimiter = (totalNumber: number) => {
  return totalNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default function TopicFollowAndTagModal({
  followers,
  total_followers,
  related_topics,
}: {
  followers: Array<User>;
  total_followers: number;
  related_topics: Array<string>;
}) {
  const numberOfFollowersText = `${seperatebyDelimiter(total_followers)} Follower${
    total_followers === 1 ? '' : 's'
  }`;

  const followedBySentence = () => {
    // head contains all the els except the last, tail is the last el. Length 1
    // arrays are special cased
    const [tail, ...head] = followers.slice(0, AVATAR_DISPLAY_LIMIT).reverse();
    // Adding Comma for large number

    // No formating required for a length 1 array
    if (total_followers === 1) {
      return <UserProfileLink user={followers[0]}>{followers[0].name}</UserProfileLink>;
    }

    // Follower profile links separated with oxford comma
    if (total_followers <= AVATAR_DISPLAY_LIMIT) {
      return head
        .map((follower, i) => [
          i > 0 && ', ',
          <UserProfileLink key={follower.id} user={follower}>
            {follower.name}
          </UserProfileLink>,
        ])
        .concat([
          ', and ',
          <UserProfileLink key={tail.id} user={tail}>
            {tail.name}
          </UserProfileLink>,
        ]);
    }

    // Follower profile links and "other" text separated with oxford comma
    return followers
      .slice(0, AVATAR_DISPLAY_LIMIT)
      .map((follower, i) => [
        i > 0 && ', ',
        <UserProfileLink key={follower.id} user={follower}>
          {follower.name}
        </UserProfileLink>,
      ])
      .concat([`, and ${seperatebyDelimiter(total_followers - AVATAR_DISPLAY_LIMIT)} others`]);
  };

  return (
    <div className={styles.topicFollowAndTagContainer}>
      {followers.length > 0 && (
        <div className={styles.followersContainer}>
          {numberOfFollowersText}
          <div className={styles.listFollowersContainer}>
            <div className={styles.stackedImgContainer}>
              {followers.slice(0, AVATAR_DISPLAY_LIMIT).map((follower, i) => {
                return (
                  <div key={follower.id} style={{ zIndex: `${AVATAR_DISPLAY_LIMIT - i}` }}>
                    <UserAvatar
                      user={follower}
                      size={AvatarSizes.Small}
                      grow={false}
                      customStyles={styles.avatarBorder}
                    />
                  </div>
                );
              })}
            </div>
            <div className={styles.followedByText}>Followed by {followedBySentence()}.</div>
          </div>
        </div>
      )}
      {related_topics.length > 0 && (
        <div className={styles.relatedTopicsContainer}>
          <div
            className={clsx(styles.relatedTopics, {
              [styles.noFollowers]: followers.length === 0,
            })}
          >
            Related Topics
          </div>
          <div className={styles.relatedTopicPills}>
            {related_topics.map((topic) => (
              <TopicPill key={topic} topic={topic} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
